import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/products/get-product-list';

  return API({ endpoint });
}
